



















import { Component, Vue, Ref } from 'vue-property-decorator';
import { AccountModule } from '@/store/modules/account';
import { FormModel } from 'ant-design-vue';
import { asLogin, IAsLogin } from '@/utils/asLoginRequest';

interface IForm {
  name: string;
  password: string;
}

@Component
export default class LoginForm extends Vue {
  private logining: boolean = false;
  @Ref() private readonly loginForm!: FormModel;
  private massageType = 'success';
  private messageTxt = '';
  private rules = {
    name: [{required: true, message: () => this.$t('login.userNameTip'), trigger: 'blur'}],
    password: [{ required: true, message: () => this.$t('login.passwordTip'), trigger: 'blur'}],
  };
  private form: IForm = {
    name: '',
    password: '',
  };
  private submitValidate() {
    (this.$refs.loginForm as FormModel).validate((valid) => {
      if (valid) {
        const {name, password} = this.form;
        this.messageTxt = '';
        this.login({
          mobile: name,
          password: encodeURIComponent(password),
        });
      } else {
        return false;
      }
    });
  }
  private toNextInput(ref: string): void {
    (this.$refs[ref] as HTMLElement).focus();
  }
  private asLogin(account: IAsLogin) {
    this.logining = true;
    asLogin(account).then((res) => {
      this.login({mobile: account.username, password: account.password});
    })
    .catch((error) => {
      this.logining = false;
      this.massageType = 'error';
      this.messageTxt = error.message;
    });
  }
  private login(account: IAuthenticate.IRequest.ILogin) {
    this.logining = true;
    AccountModule.Login(account)
    .then((res) => {
      this.logining = false;
      this.massageType = 'success';
      this.messageTxt = this.$t('login.welcome') + `, ${res.user.name}`;
      setTimeout(() => {
        this.messageTxt = '';
        this.$emit('logined');
      }, 1000);
    })
    .catch((error) => {
      this.logining = false;
      this.massageType = 'error';
      this.messageTxt = error;
    });
  }
}
